export const RECEIVED = "received"
export const GIVEN = "given"
export const DRAFT = "draft"
